import { productService } from '../services/productService';
import { categoryService } from '../services/categoryService';
import { authService } from '../services/authService';

export function getAllProducts() {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADING', payload: true });
            const products = await productService.getAllProducts();
            console.log('Products fetched successfully:', products);
            return dispatch({
                type: 'GET_PRODUCTS',
                payload: products
            });
        } catch (error) {
            console.error('Error fetching products:', error);
            dispatch({ type: 'SET_ERROR', payload: error.message });
        } finally {
            dispatch({ type: 'SET_LOADING', payload: false });
        }
    }
}

export function getProductById(id) {
    return async (dispatch) => {
        try {
            const product = await productService.getProductById(id);
            return dispatch({
                type: 'PRODUCT_ID',
                payload: product
            });
        } catch (error) {
            console.error('Error fetching product:', error);
            dispatch({ type: 'SET_ERROR', payload: error.message });
        }
    }
}

export function getAllCategories() {
    return async (dispatch) => {
        try {
            const categories = await categoryService.getAllCategories();
            return dispatch({
                type: 'GET_CATEGORIES',
                payload: categories
            });
        } catch (error) {
            console.error('Error fetching categories:', error);
            dispatch({ type: 'SET_ERROR', payload: error.message });
        }
    }
}

export function loginUser(email, password) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADING', payload: true });
            const { user } = await authService.login(email, password);
            dispatch({
                type: 'LOGIN_SUCCESS',
                payload: { user }
            });
            return { success: true };
        } catch (error) {
            dispatch({ type: 'LOGIN_FAILURE', payload: error.response?.data?.message || error.message });
            return { success: false, error: error.response?.data?.message || error.message };
        } finally {
            dispatch({ type: 'SET_LOADING', payload: false });
        }
    }
}

export function registerUser(userData) {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_LOADING', payload: true });
            const { user } = await authService.register(userData);
            dispatch({
                type: 'LOGIN_SUCCESS',
                payload: { user }
            });
            return { success: true };
        } catch (error) {
            dispatch({ type: 'REGISTER_FAILURE', payload: error.response?.data?.message || error.message });
            return { success: false, error: error.response?.data?.message || error.message };
        } finally {
            dispatch({ type: 'SET_LOADING', payload: false });
        }
    }
}

export function logoutUser() {
    return (dispatch) => {
        authService.logout();
        dispatch({ type: 'LOGOUT' });
    }
}

export function createProduct(productData) {
    return async (dispatch) => {
        try {
            const product = await productService.createProduct(productData);
            console.log('Product created successfully:', product);
            dispatch({
                type: 'ADD_PRODUCT',
                payload: product
            });
            return { success: true, product };
        } catch (error) {
            console.error('Error creating product:', error);
            return { success: false, error: error.response?.data?.message || error.message };
        }
    }
}

export function updateProduct(id, productData) {
    return async (dispatch) => {
        try {
            // console.log('Updating product with ID:', id, 'and data:', productData);
            const product = await productService.updateProduct(id, productData);
            dispatch({
                type: 'UPDATE_PRODUCT',
                payload: product
            });
            return { success: true, product };
        } catch (error) {
            console.error('Error updating product:', error);
            return { success: false, error: error.response?.data?.message || error.message };
        }
    }
}

export function deleteProduct(id) {
    return async (dispatch) => {
        try {
            await productService.deleteProduct(id);
            dispatch({
                type: 'DELETE_PRODUCT',
                payload: id
            });
            return { success: true };
        } catch (error) {
            console.error('Error deleting product:', error);
            return { success: false, error: error.response?.data?.message || error.message };
        }
    }
}

export const changeSideBar = () => ({
    type: 'SIDEBAR'
})

export const toggleFilterSidebar = () => ({
    type: 'TOGGLE_FILTER_SIDEBAR'
})

export function addToCart(payload) {
    return {
        type: 'ADD_TO_CART',
        payload
    }
}

export function deleteOneProduct(payload) {
    return {
        type: 'DELETE_ONE_PRODUCT',
        payload
    }
}

export function clearCart() {
    return {
        type: 'CLEAR_CART'
    }
}

export function increaseQuantity(payload) {
    return {
        type: 'INCREASE_QUANTITY',
        payload
    }
}

export function decreaseQuantity(payload) {
    return {
        type: 'DECREASE_QUANTITY',
        payload
    }
}

export function clearProduct() {
    return {
        type: 'CLEAR_PRODUCT'
    }
}

export function searchBar(payload) {
    return async (dispatch) => {
        try {
            if (payload.trim() === '') {
                dispatch(getAllProducts());
            } else {
                const products = await productService.searchProducts(payload);
                dispatch({
                    type: 'SEARCH_PRODUCTS',
                    payload: products
                });
            }
        } catch (error) {
            console.error('Error searching products:', error);
        }
    }
}

export function getMenuFilter(payload) {
    return {
        type: 'FILTER_MENU',
        payload
    }
}

export function orderBy(payload) {
    return {
        type: 'ORDER_BY',
        payload
    }
}